export default {
  campaign: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  campaignFiles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  participantsCampaign: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
